<div class="background">
  <mat-card appearance="outlined">
    <div class="text-center p-b-20 p-t-20">
      <img
        src="/assets/img/glimpse-logo-blue-extended.png"
        srcset="/assets/img/glimpse-logo-blue-extended.png, /assets/img/glimpse-logo-blue-extended@2x.png 2x"
      />
    </div>
    <hr class="m-0 p-0" />
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</div>
